import { render } from "./VoucherDocument.vue?vue&type=template&id=48fd1222"
import script from "./VoucherDocument.vue?vue&type=script&lang=js"
export * from "./VoucherDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__